import { useEffect } from "react";

/**
 * Calendly inline embed.
 *
 *  ─────────────────────────────────────────────────────────────────
 *  CALENDLY_URL is the base scheduling URL. The component appends the
 *  visitor's name and email as prefill URL params after they submit
 *  the inquiry form, so they don't have to type them a second time.
 *  ─────────────────────────────────────────────────────────────────
 */
export const CALENDLY_URL =
  "https://calendly.com/flory-florentina/30min?background_color=e5daca&text_color=4a5568&primary_color=c97a52";

const withPrefill = (baseUrl, name, email) => {
  if (!name && !email) return baseUrl;
  const sep = baseUrl.includes("?") ? "&" : "?";
  const params = [];
  if (name) params.push(`name=${encodeURIComponent(name)}`);
  if (email) params.push(`email=${encodeURIComponent(email)}`);
  return `${baseUrl}${sep}${params.join("&")}`;
};

export const CalendlyEmbed = ({ name = "", email = "" }) => {
  useEffect(() => {
    const id = "calendly-widget-script";
    if (document.getElementById(id)) return;
    const script = document.createElement("script");
    script.id = id;
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const url = withPrefill(CALENDLY_URL, name, email);

  return (
    <div
      data-testid="calendly-inline-embed"
      className="calendly-inline-widget"
      data-url={url}
      style={{
        minWidth: "320px",
        height: "720px",
        width: "100%",
        background: "transparent",
      }}
    />
  );
};

export default CalendlyEmbed;
